import 'modern-css-reset'
import './style.sass'

import './scripts/heroViewAnimation'
import './scripts/textAnimations'
import './scripts/loadingAnimation'
import './scripts/avaterSwitcher'
